import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import type { RepartoMensualPunto } from '@/contabilidad/utils/aggregations';
import type { Moneda } from '@/contabilidad/types';
import { formatCurrencyCompact } from '@/contabilidad/utils/formatters';

interface EvolucionRepartosChartProps {
  data: RepartoMensualPunto[];
  socios: string[];
  /** Mapa socio → color, compartido con el donut de participación para que cada socio use el mismo color en ambos gráficos. */
  colorMap: Record<string, string>;
  moneda: Moneda;
}

export function EvolucionRepartosChart({ data, socios, colorMap, moneda }: EvolucionRepartosChartProps) {
  const sinDatos = socios.length === 0 || data.every((punto) =>
    socios.every((socio) => !punto[socio]),
  );

  if (data.length === 0 || sinDatos) {
    return (
      <div className="flex items-center justify-center h-[280px] text-xs text-muted-foreground">
        Sin datos disponibles
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={280}>
      <BarChart data={data} margin={{ top: 4, right: 4, left: 8, bottom: 4 }}>
        <CartesianGrid strokeDasharray="4 4" stroke="#e5e7eb" vertical={false} />
        <XAxis dataKey="mes" tick={{ fontSize: 12 }} axisLine={false} tickLine={false} />
        <YAxis
          tickFormatter={(v) => formatCurrencyCompact(v, moneda)}
          tick={{ fontSize: 11 }}
          axisLine={false}
          tickLine={false}
          width={68}
        />
        <Tooltip
          formatter={(value: number) => formatCurrencyCompact(value, moneda)}
          contentStyle={{ borderRadius: '8px', border: '1px solid #e5e7eb', fontSize: '12px' }}
        />
        <Legend wrapperStyle={{ fontSize: '12px' }} />
        {socios.map((socio, index) => (
          <Bar
            key={socio}
            dataKey={socio}
            name={socio}
            stackId="socios"
            fill={colorMap[socio]}
            radius={index === socios.length - 1 ? [4, 4, 0, 0] : undefined}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
}
